import React from 'react';
import { Error } from './';

export const FormRow = ({ label, error, formField, ...props }) => (
  <>
    <div className="flex w-full py-2 leading-10" data-form-field={formField}>
      <div className="mr-4 mt-[10px] w-[200px] text-right leading-normal">
        <label className="text-[0.9rem] uppercase [&_svg]:text-[1.5rem] [&_svg]:text-[var(--primary)]">
          {label}
        </label>
      </div>
      <div className="w-full [&_input]:w-full [&_select]:w-full [&_textarea]:w-full">
        {props.children}
        {error ? <Error>{error}</Error> : null}
      </div>
    </div>
  </>
);
